export default {
    setPrivilegeinfo(state, payload){
        for (const key of Object.keys(payload)) {
            Array.prototype.push.apply(state.allPrivileges[key], payload[key])    
        }
    },
    setActionsinfo(state, payload){
        state.enabledActions = []
        Array.prototype.push.apply(state.enabledActions, payload)
        state.enabledActions.sort(
            function(a, b) {
                var textA = a.action_name.toUpperCase();
                var textB = b.action_name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            }
        )
    },
    unsetActionsinfo(state){
        state.enabledActions = []
    },

    resetPrivileges(state){
       for(let key in state.allPrivileges){
           if(state.allPrivileges[key] && Array.isArray(state.allPrivileges[key])){
              state.allPrivileges[key].length = 0;
           }
       }
       if(state.enabledActions && Array.isArray(state.enabledActions))
           state.enabledActions.length = 0;
    }
};
